/**
 * Define and Export Action Types
 */

export const LOAD_USER_REQUEST = 'LOAD_USER_REQUEST'
export const LOAD_USER_RECEIVE = 'LOAD_USER_RECEIVE'
export const LOAD_USER_FAILURE = 'LOAD_USER_FAILURE'
export const PROFILE_UPDATE_REQUEST = 'PROFILE_UPDATE_REQUEST'
export const PROFILE_UPDATE_RECEIVE = 'PROFILE_UPDATE_RECEIVE'
export const PROFILE_UPDATE_FAILURE = 'PROFILE_UPDATE_FAILURE'
export const API_KEY_REQUEST = 'API_KEY_REQUEST'
export const API_KEY_RECEIVE = 'API_KEY_RECEIVE'
export const API_KEY_FAILURE = 'API_KEY_FAILURE'
export const API_USAGE_REQUEST = 'API_USAGE_REQUEST'
export const API_USAGE_RECEIVE = 'API_USAGE_RECEIVE'
export const API_USAGE_FAILURE = 'API_USAGE_FAILURE'
export const RESEND_EMAIL_VERIFICATION_REQUEST = 'RESEND_EMAIL_VERIFICATION_REQUEST'
export const RESEND_EMAIL_VERIFICATION_RECEIVE = 'RESEND_EMAIL_VERIFICATION_RECEIVE'
export const RESEND_EMAIL_VERIFICATION_FAILURE = 'RESEND_EMAIL_VERIFICATION_FAILURE'
export const PROGRESS_UPDATE_REQUEST = 'PROGRESS_UPDATE_REQUEST'
export const PROGRESS_UPDATE_RECEIVE = 'PROGRESS_UPDATE_RECEIVE'
export const PROGRESS_UPDATE_FAILURE = 'PROGRESS_UPDATE_FAILURE'
export const LOAD_ADVOCATE_REQUEST = 'LOAD_ADVOCATE_REQUEST'
export const LOAD_ADVOCATE_RECEIVE = 'LOAD_ADVOCATE_RECEIVE'
export const LOAD_ADVOCATE_FAILURE = 'LOAD_ADVOCATE_FAILURE'
export const LOAD_AFFILIATE_REQUEST = 'LOAD_AFFILIATE_REQUEST'
export const LOAD_AFFILIATE_RECEIVE = 'LOAD_AFFILIATE_RECEIVE'
export const LOAD_AFFILIATE_FAILURE = 'LOAD_AFFILIATE_FAILURE'
export const LOAD_AFFILIATE_RESOURCE_REQUEST = 'LOAD_AFFILIATE_RESOURCE_REQUEST'
export const LOAD_AFFILIATE_RESOURCE_RECEIVE = 'LOAD_AFFILIATE_RESOURCE_RECEIVE'
export const LOAD_AFFILIATE_RESOURCE_FAILURE = 'LOAD_AFFILIATE_RESOURCE_FAILURE'
export const VERIFY_AFFILIATE_REQUEST = 'VERIFY_AFFILIATE_REQUEST'
export const VERIFY_AFFILIATE_RECEIVE = 'VERIFY_AFFILIATE_RECEIVE'
export const VERIFY_AFFILIATE_FAILURE = 'VERIFY_AFFILIATE_FAILURE'
export const UPDATE_AFFILIATE_PAYPAL_REQUEST = 'UPDATE_AFFILIATE_PAYPAL_REQUEST'
export const UPDATE_AFFILIATE_PAYPAL_RECEIVE = 'UPDATE_AFFILIATE_PAYPAL_RECEIVE'
export const UPDATE_AFFILIATE_PAYPAL_FAILURE = 'UPDATE_AFFILIATE_PAYPAL_FAILURE'
export const SEND_INVITE_REQUEST = 'SEND_INVITE_REQUEST'
export const SEND_INVITE_RECEIVE = 'SEND_INVITE_RECEIVE'
export const SEND_INVITE_FAILURE = 'SEND_INVITE_FAILURE'
export const RESEND_INVITE_REQUEST = 'RESEND_INVITE_REQUEST'
export const RESEND_INVITE_RECEIVE = 'RESEND_INVITE_RECEIVE'
export const RESEND_INVITE_FAILURE = 'RESEND_INVITE_FAILURE'
export const REQUEST_UPDATE = 'REQUEST_UPDATE'
export const AFFILIATE_RESOURCE_DOWNLOAD_REQUEST = 'AFFILIATE_RESOURCE_DOWNLOAD_REQUEST'
export const AFFILIATE_RESOURCE_DOWNLOAD_RECEIVE = 'AFFILIATE_RESOURCE_DOWNLOAD_RECEIVE'
export const AFFILIATE_RESOURCE_DOWNLOAD_FAILURE = 'AFFILIATE_RESOURCE_DOWNLOAD_FAILURE'
export const USER_SET_EMAIL_VERIFIED = 'USER_SET_EMAIL_VERIFIED'
export const ADD_USER_COURSE = 'ADD_USER_COURSE'
export const UPDATE_USER_WATCHLIST_PRICE_TARGET = 'UPDATE_USER_WATCHLIST_PRICE_TARGET'
export const UPDATE_COMPANIES_WITH_MODELS = 'UPDATE_COMPANIES_WITH_MODELS'
export const UPDATE_USER_SCREENS = 'UPDATE_USER_SCREENS'
export const UPDATE_USER_PLAN = 'UPDATE_USER_PLAN'
export const SET_USER_DATA = 'SET_USER_DATA'
